import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'gen-common-options-button',
  templateUrl: './common-options-button.component.html',
  styleUrls: ['./common-options-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CommonOptionsButtonComponent implements OnInit {
  @Input() options: Array<{ label: string, command: () => void }>;
  @Input() buttonText: string;
  @Input() buttonIconClass: string;
  @Input() disabled: boolean;

  @Output() mainOption: EventEmitter<any> = new EventEmitter<any>();
  public active: boolean = false;

  constructor() {
  }

  ngOnInit() {
  }

  onClick() {
    this.active = false;
    this.mainOption.emit(true);
  }

  trackByFn(item, index) {
    return item ? item.label : index;
  }
}
